/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_SendSmsDto } from '../models/BigClock_Api_Models_SendSmsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TechnicalService {
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiTechnicalSendSms(
        requestBody?: BigClock_Api_Models_SendSmsDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Technical/send-sms',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
